// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 추가 기능 허브 — 퇴직정산 유형 선택 화면과 동일한 톤 */
.extras-hub {
  min-height: calc(100vh - 80px);
  background-color: #f8f9fa;
  text-align: center;
  padding: 2rem;
}

.extras-message {
  max-width: 900px;
  margin: 0 auto 2rem;
}

.extras-message-box {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid #dee2e6;
}

.extras-message-box h2 {
  color: #495057;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.extras-message-box p {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

.extras-option-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.extras-option-card {
  background: white;
  border: 2px solid #e3f2fd;
  border-radius: 15px;
  padding: 1.5rem;
  width: 280px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.08);
  text-align: center;
}

.extras-option-card:hover {
  transform: translateY(-4px);
  border-color: #2196f3;
  box-shadow: 0 8px 20px rgba(33, 150, 243, 0.2);
}

.extras-option-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.extras-option-card h3 {
  color: #1976d2;
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.extras-option-card > p {
  color: #6c757d;
  font-size: 0.85rem;
  margin: 0 0 1rem 0;
}

.extras-option-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.extras-option-features li {
  background: linear-gradient(135deg, #e3f2fd, #f1f8ff);
  color: #1565c0;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8rem;
}

.extras-footer {
  border-top: 1px solid #e9ecef;
  padding-top: 1.5rem;
  color: #6c757d;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ExtrasHub.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* 추가 기능 허브 — 퇴직정산 유형 선택 화면과 동일한 톤 */\n.extras-hub {\n  min-height: calc(100vh - 80px);\n  background-color: #f8f9fa;\n  text-align: center;\n  padding: 2rem;\n}\n\n.extras-message {\n  max-width: 900px;\n  margin: 0 auto 2rem;\n}\n\n.extras-message-box {\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  border-radius: 15px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  border: 1px solid #dee2e6;\n}\n\n.extras-message-box h2 {\n  color: #495057;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n}\n\n.extras-message-box p {\n  color: #6c757d;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.extras-option-cards {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.extras-option-card {\n  background: white;\n  border: 2px solid #e3f2fd;\n  border-radius: 15px;\n  padding: 1.5rem;\n  width: 280px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.08);\n  text-align: center;\n}\n\n.extras-option-card:hover {\n  transform: translateY(-4px);\n  border-color: #2196f3;\n  box-shadow: 0 8px 20px rgba(33, 150, 243, 0.2);\n}\n\n.extras-option-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.extras-option-card h3 {\n  color: #1976d2;\n  font-size: 1.15rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n}\n\n.extras-option-card > p {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin: 0 0 1rem 0;\n}\n\n.extras-option-features ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.extras-option-features li {\n  background: linear-gradient(135deg, #e3f2fd, #f1f8ff);\n  color: #1565c0;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.8rem;\n}\n\n.extras-footer {\n  border-top: 1px solid #e9ecef;\n  padding-top: 1.5rem;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
